import React from 'react'
import Link from 'next/link'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'
import { BUKTI_KARYA_CATEGORIES } from 'app/ProfileRevampPage/constants'
import { capitalizeEachWords } from 'utils/text'

interface BuktiKaryaListItemProps
  extends React.HTMLAttributes<HTMLAnchorElement> {
  category?: string
  subtitle?: string
  href?: string
}

function BuktiKaryaListItem({
  category,
  subtitle,
  href = '#',
  ...props
}: BuktiKaryaListItemProps) {
  const { SETrackClickBuktiKaryaCategory } = useSETrackEvent()

  const onClickItem = () => {
    SETrackClickBuktiKaryaCategory({
      buktiKaryaCategory: category,
    })
  }

  const icon = BUKTI_KARYA_CATEGORIES?.[category]?.icon ?? ''
  const title =
    BUKTI_KARYA_CATEGORIES?.[category]?.title ??
    capitalizeEachWords(category.replace(/_/g, ' '))

  return (
    <Link href={href} passHref>
      <a
        {...props}
        className="flex items-center gap-4 py-4 cursor-pointer"
        onClick={onClickItem}
      >
        <Icon>{icon}</Icon>
        <div>
          <Text variant="action">
            <span data-testid="profile-bukti-karya-list-item-title">
              {title}
            </span>
          </Text>
          <Text variant="body" color="subdued">
            {subtitle}
          </Text>
        </div>
      </a>
    </Link>
  )
}

export default BuktiKaryaListItem
